import { Box, Stack, Tooltip } from "@mui/material";
import { Text } from "@src/appV2/redesign/components/Text";
import { ValueCell } from "./ValueCell";

interface UpdatedFieldContainerProps {
  fieldKey: string;
  previousValue: unknown;
  newValue: unknown;
}

export function UpdatedFieldContainer(props: UpdatedFieldContainerProps) {
  const { fieldKey, previousValue, newValue } = props;

  return (
    <Stack spacing={0.25}>
      <Tooltip title={fieldKey} placement="top">
        <Box
          sx={{ maxWidth: 350, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
        >
          <Text variant="body2" bold inline>
            {fieldKey}
          </Text>
        </Box>
      </Tooltip>
      <Stack direction="row" spacing={1} alignItems="flex-start">
        <Text inline variant="body2" minWidth={80}>
          New:
        </Text>
        <ValueCell value={newValue} />
      </Stack>

      <Stack direction="row" spacing={1} alignItems="flex-start">
        <Text inline variant="body2" minWidth={80} color="text.secondary">
          Previous:
        </Text>
        <ValueCell value={previousValue} muted />
      </Stack>
    </Stack>
  );
}
